import React from 'react'

const ExplorePage = () => {
  return (
    <div>
        EXPLORE PAGE FOR REAL
    </div>
  )
}

export default ExplorePage;